//
import { formatarDinheiro } from '../../shared/helper';
import { FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { SIDE_PADDING, TXT_P } from '../../constants';
import { useIsBigScreen } from '../../helper';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import CardInfo from './CardInfo';

const COVER_HEIGHT = 150;
const LOGO_HEIGHT = 150;
const TOP_OFFSET = COVER_HEIGHT - 15 - LOGO_HEIGHT / 2;

type Props = {
  mostrarInfos?: boolean;
};

const ApresentacaoEmpresa: React.FC<Props> = (props) => {
  const { mostrarInfos } = props;
  const [empresa] = useEmpresa();

  if (!empresa) {
    return null;
  }

  let stringDelivery = `R$ ${formatarDinheiro(empresa.precoDelivery)}`;
  if (empresa.precoDelivery === 0) {
    stringDelivery = 'GRÁTIS!';
  }
  if (empresa.valorMinimoDeliveryGratis > 0) {
    stringDelivery = '';
  }

  return (
    <View style={styles.container}>
      <Image
        source={require('../../../assets/delivery.jpg')}
        style={{ width: '100%', height: COVER_HEIGHT + 30, resizeMode: 'cover' }}
        blurRadius={3}
      />
      <Image source={require('../../../assets/logo.png')} style={styles.logo} />

      <View style={styles.viewInfos}>
        {mostrarInfos !== false && empresa.aberto && (
          <View style={styles.viewContentInfos}>
            <CardInfo
              icon={<Image source={require('../../../assets/bike.png')} style={styles.icon} />}
              title={'DELIVERY'}
              value={`${empresa.tempoDelivery} min.\n${stringDelivery}`}
            />

            <CardInfo
              icon={<Image source={require('../../../assets/cloche.png')} style={styles.icon} />}
              title={'BALCÃO'}
              value={`${empresa.tempoBalcao} min.`}
            />

            {empresa.valorMinimoDeliveryGratis > 0 && (
              <CardInfo
                icon={<MaterialIcons name="attach-money" size={30} color="#fff" />}
                title={`ABAIXO DE R$${empresa.valorMinimoDeliveryGratis}`}
                value={`ENTREGA\nR$ ${formatarDinheiro(empresa.precoDelivery)}`}
              />
            )}

            {empresa.pedidoMinimo > 0 && (
              <CardInfo
                icon={<MaterialIcons name="attach-money" size={30} color="#fff" />}
                title={'MÍNIMO'}
                value={`R$ ${formatarDinheiro(empresa.pedidoMinimo)}`}
              />
            )}
          </View>
        )}

        {mostrarInfos !== false && !empresa.aberto && (
          <View style={styles.viewFechado}>
            <FontAwesome5 name="sad-tear" size={30} color={'#fff'} style={{ marginBottom: 5 }} />
            <Text style={{ fontSize: TXT_P, color: '#fff', fontWeight: '700' }}>
              ESTAMOS FECHADOS
            </Text>

            {Boolean(empresa.horarioFuncionamento) && (
              <Text style={{ fontSize: TXT_P, color: '#fff', fontWeight: '700', marginTop: 5 }}>
                Funcionamento:{'\n'}
                {empresa.horarioFuncionamento}
              </Text>
            )}
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%'
    // marginBottom: TOP_PADDING
  },
  containerWeb: {
    width: '100%'
    // marginBottom: TOP_PADDING
  },
  viewInfos: {
    paddingTop: TOP_OFFSET + 10,
    top: -30,
    position: 'relative',
    width: '100%',
    backgroundColor: '#fff',
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40
  },
  viewContentInfos: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    maxWidth: 600,
    width: '100%',
    alignSelf: 'center',
    flex: 1
  },
  logo: {
    width: '60%',
    height: LOGO_HEIGHT,
    resizeMode: 'contain',
    alignSelf: 'center',
    top: TOP_OFFSET,
    position: 'absolute',
    zIndex: 2
  },
  viewFechado: {
    backgroundColor: colors.red,
    borderRadius: 7,
    padding: 7,
    marginLeft: 15,
    marginRight: 15,
    flex: 1,
    alignItems: 'center'
  },
  icon: { height: 30, width: 30 }
});

export default ApresentacaoEmpresa;
